// extracted by mini-css-extract-plugin
module.exports = {"performanceParent":"Performance_performanceParent__XQ8WU"};